<ng-container [formGroup]="parent">
  <div [formGroupName]="formgroupName" class="hidecollapseinchild">
    <div class="form-group has-float-label mb-2">
      <div class="form-group has-float-label">
        <label class="form-label"
          >Delivery Address <span class="madatory-field">*</span></label
        >
        <p-select
          [formControlName]="addressField.deliveryAddressfield"
          (onChange)="onDeliveryAddressChange($event, shipAddressPopover)"
          [ngClass]="{
            'has-error': formErrors[addressField.deliveryAddressfield],
          }"
          (blur)="logValidationErrors()"
          [options]="deliveryAddress"
          optionLabel="name"
          optionValue="name"
          optionDisabled="status">
        </p-select>

        <span
          class="error-msg"
          *ngIf="formErrors[addressField.deliveryAddressfield]">
          {{ formErrors[addressField.deliveryAddressfield] }}
        </span>
      </div>
    </div>

    <div class="ship-address" [style]="{ position: 'relative' }" #shipaddress>
      <div
        class="form-group has-float-label mb-2"
        *ngIf="shipToAddress"
        id="dropdownBasic2">
        <label class="form-label">Client Ship To Name </label>
        <input
          #shipToInput
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="shiftToAddressField"
          (click)="onshipToAddressFilter($event, shipAddressPopover)" />
      </div>
      <p-popover
        styleClass="pop2"
        [dismissable]="true"
        [appendTo]="shipaddress"
        #shipAddressPopover
        aria-labelledby="dropdownBasic2"
        ariaCloseLabel="close">
        <p-table
          #dt
          [value]="shiftToAddressList"
          styleClass="p-datatable-customers po-small"
          [rowHover]="true"
          [rows]="10"
          [scrollable]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0"
          [scrollable]="true"
          scrollHeight="400px"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="name">Name and Description</th>
              <th class="name">Address</th>
              <th class="vaccount">Street</th>
              <th class="sname">Purpose</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-shiftToAddressLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onShitToAddressSeletion(shiftToAddressLists, shipAddressPopover)
              ">
              <td class="name mousepointer">
                {{ shiftToAddressLists.descriptionD365 }}
              </td>
              <td class="name mousepointer">
                {{ shiftToAddressLists.addressD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ shiftToAddressLists.streetD365 }}
              </td>
              <td class="sname mousepointer">
                {{ shiftToAddressLists.rolesD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>

    <div class="v-account" #vendoracount>
      <div
        class="form-group has-float-label mb-2"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic5">
        <label class="form-label">Vendor Account</label>
        <input
          #vendorAccountInputElt
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="vendorAccountSeletion"
          (input)="searchVendor$.next($any($event.target).value)"
          (keypress)="
            onVendorSearchOpenToggle(
              vendorPopover,
              $event,
              vendorAccountInputElt
            )
          " />
      </div>
      <p-popover
        styleClass="pop3"
        [appendTo]="'body'"
        aria-labelledby="dropdownBasic5"
        #vendorPopover>
        <div class="indropdowntable" style="height: 200px">
          <p-table
            #dt
            stripedRows
            [size]="'small'"
            scrollHeight="300px"
            [value]="vendorList"
            styleClass="p-datatable-customers order-listing"
            styleClass="popuptable"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0">
            <ng-template pTemplate="header">
              <tr>
                <th class="name">Name or description</th>
                <th class="vaccount">Address</th>
                <th class="sname">Purpose</th>
                <th class="sname">Primary</th>
                <th class="sname">Val</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-vendorList
              let-rowIndex="rowIndex">
              <tr
                class="p-selectable-row mousepointer"
                (click)="onVendorAccountSelection(vendorList, vendorPopover)">
                <td class="name mousepointer">
                  {{ vendorList.vendorName }}
                </td>
                <td class="vaccount mousepointer">
                  {{ vendorList.addressD365 }}
                </td>
                <td class="sname mousepointer">
                  {{ vendorList.purpose }}
                </td>
                <td class="sname mousepointer">
                  {{ vendorList.primary }}
                </td>
                <td class="sname mousepointer">
                  <input
                    pInputText
                    [disabled]="true"
                    class="form-check-input me-2"
                    type="checkbox" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No address found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-popover>
    </div>

    <div #vendoraddressbook class="selectionvisible">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic6">
        <label class="form-label">Vendor Address Book</label>
        <input
          pInputText
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="addressBookName"
          (click)="onVendorAddressBookSelect($event, addressBookPopover)" />
      </div>
      <p-popover
        styleClass="pop1"
        [appendTo]="'body'"
        aria-labelledby="dropdownBasic6"
        #addressBookPopover>
        <p-table
          #dt
          [value]="addressBookList"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="vaccount">Address</th>
              <th class="sname">Purpose</th>
              <th class="sname">Street</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-addressBookLists
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onVendorAddressBookSelection(
                  addressBookLists,
                  addressBookPopover
                )
              ">
              <td class="vaccount mousepointer">
                {{ addressBookLists.addressD365 }}
              </td>
              <td class="sname mousepointer">
                {{
                  addressBookLists.purposeD365 === "1" ? "Busniess" : "Others"
                }}
              </td>
              <td class="vaccount mousepointer">
                {{ addressBookLists.streetD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>

    <!-- <div class="form-group has-float-label mb-2" [hidden]="!showAddress">
      <textarea pInputText
        jniAutoCompleteBlocker
        placeholder=""
        class="form-control"
        formControlName="addressD365"
      ></textarea>
      <label class="form-label">Address</label>
    </div> -->

    <div
      class="form-group has-float-label mb-2 address-lookup"
      [hidden]="showAddress">
      <label class="form-label">Address Lookup</label>
      <p-autoComplete
        [(ngModel)]="melissa"
        [suggestions]="melissaSearchResult"
        [optionLabel]="'Address.Address'"
        (completeMethod)="searchMelissaAutoComplete($event)"
        [forceSelection]="false"
        [dropdown]="false"
        (onSelect)="selectedStreet($event)"
        (onChange)="enableAndDisabledValidateButton()"
        placeholder="Enter address"
        [inputStyle]="{ width: '100%' }"
        [formControlName]="addressField.addressFormatField"
        id="addressFormat"
        name="addressFormat">
        <ng-template let-address #item>
          {{ melissaFormatter(address) }}
        </ng-template>
      </p-autoComplete>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ selectionvisible: !collapseStatus }"
      [hidden]="showAddress">
      <label class="form-label"
        >Country/Region <span class="madatory-field">*</span></label
      >
      <p-select
        [(ngModel)]="countryRegionSelectedId"
        [formControlName]="addressField.countryRegionfield"
        [ngClass]="{ 'has-error': formErrors[addressField.countryRegionfield] }"
        (blur)="logValidationErrors()"
        (onChange)="onCountryRegionSelection(countryRegionSelectedId)"
        [options]="countryRegionList"
        optionLabel="countryRegionD365"
        optionValue="countryRegionD365"
        [filter]="'true'">
      </p-select>

      <span
        class="error-msg"
        *ngIf="formErrors[addressField.countryRegionfield]">
        {{ formErrors[addressField.countryRegionfield] }}
      </span>
    </div>

    <div
      [ngClass]="{ hidechildelement: appartmentFieldStatus }"
      [hidden]="appartmentFieldStatus">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="appartmentList.length">
        <label class="form-label">Suite Selection Box</label>
        <p-select
          [(ngModel)]="selectedAppartment"
          formControlName="buildingComplimentD365"
          (onChange)="onAppartmentSelection($event)"
          [ngClass]="{ 'has-error': !appartmentFieldStatus }"
          [options]="appartmentList"
          #selector>
        </p-select>
      </div>
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >Address Line 1<span class="madatory-field">*</span></label
      >
      <p-autoComplete
        [suggestions]="melissaNonUsSearchResult"
        [optionLabel]="'Address.Address'"
        (completeMethod)="getMelissaGlobalData($event.query)"
        [forceSelection]="false"
        [dropdown]="false"
        (onSelect)="selectedStreetForNonUs($event)"
        (onChange)="enableAndDisabledValidateButton()"
        placeholder="Enter address"
        [inputStyle]="{ width: '100%' }"
        [formControlName]="addressField.addressFormatField"
        id="addressFormat"
        name="addressFormat">
        <ng-template let-addressnonus #item>
          {{ melissaFormatterNonUs(addressnonus) }}
        </ng-template>
      </p-autoComplete>
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label">Address Line 2</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [formControlName]="addressField.addressLine2Field"
        [(ngModel)]="address2" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label">Address Line 3</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        [formControlName]="addressField.addressLine3Field"
        [(ngModel)]="address3" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >City/Locality <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="cityD365"
        name="cityD365"
        placeholder=""
        [formControlName]="addressField.cityD365Field"
        [(ngModel)]="city"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >State/Province <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="stateD365"
        name="stateD365"
        placeholder=""
        [formControlName]="addressField.stateD365Field"
        [(ngModel)]="state"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >Postal Code <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="zipCodeD365"
        name="zipCodeD365"
        placeholder=""
        [formControlName]="addressField.zipCodeD365Field"
        [(ngModel)]="postalcode"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: nonUsandCadFieldStatus }"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label"
        >Street <span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="streetD365"
        name="streetD365"
        placeholder=""
        [formControlName]="addressField.streetD365Field" />
    </div>

    <div class="form-group has-float-label mb-2" *ngIf="showName">
      <label class="form-label">Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        formControlName="deliveryNameD365"
        [ngClass]="{ 'has-error': formErrors['deliveryNameD365'] }"
        (blur)="logValidationErrors()" />

      <span class="error-msg" *ngIf="formErrors['deliveryNameD365']">
        {{ formErrors["deliveryNameD365"] }}
      </span>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{
        selectionvisible: !collapseStatus,
        selectionforcedvisible: attentionFieldStatus,
      }">
      <label class="form-label">Attention</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        [formControlName]="addressField.attentionInformationD365Field"
        maxlength="30" />
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ selectionvisible: !collapseStatus }">
      <label class="form-label">location</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        [formControlName]="addressField.locationD365Field"
        maxlength="30" />
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ selectionvisible: !collapseStatus }">
      <label class="form-label" for="c_name">Address</label>
      <textarea
        pInputText
        jniAutoCompleteBlocker
        [formControlName]="addressField.addressD365Field"
        class="form-control"
        style="height: 100px"
        (change)="formattedAddressChange()"
        [ngClass]="{ 'has-error': isAddressError }"></textarea>

      <span class="error-msg" *ngIf="isAddressError">
        Address is not valid
      </span>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [ngClass]="{ hidechildelement: isPrimaryFieldStatus }"
      [hidden]="isPrimaryFieldStatus">
      <div class="switcher">
        <div class="form-label mb-1">Primary:</div>
        <div class="d-flex align-items-center form-switch">
          <label class="form-check-label" for="rcCheck">{{
            this.parent.get(["addressInformation", "isPrimaryD365"])?.value
          }}</label>
          <input
            pInputText
            name="rcCheck"
            class="form-check-input me-2"
            [checked]="false"
            type="checkbox"
            id="rcCheck"
            [formControlName]="addressField.isPrimaryD365Field" />
        </div>
      </div>
    </div>

    <div class="form-group has-float-label mb-2" [hidden]="true">
      <label class="form-label" for="c_name">validateAddress</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        [formControlName]="addressField.validateAddressField"
        class="form-control"
        style="height: 120px" />
    </div>

    <div class="col mb-2 d-flex align-items-center justify-content-end">
      <div class="form-group has-float-label">
        <button
          type="button"
          style="margin-left: 10px"
          (click)="validateAddress(true)"
          [hidden]="hideValidateButton"
          class="btn validate"
          [ngClass]="{
            'btn-success': addressValidationStatus === false,
            'btn-primary': addressValidationStatus === true,
            'btn-danger': isAddressError === true,
          }">
          Validate address
        </button>
      </div>
    </div>

    <div
      class="form-group has-float-label mt-3"
      [ngClass]="{ selectionvisible: !collapseStatus }">
      <label class="form-label">Ship to email</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="email"
        class="form-control"
        placeholder=""
        [formControlName]="addressField.shipToEmail"
        [ngClass]="{ 'has-error': formErrors['shipToEmail'] }"
        (blur)="logValidationErrors()" />

      <span class="error-msg" *ngIf="formErrors['shipToEmail']">
        {{ formErrors["shipToEmail"] }}
      </span>
    </div>
  </div>
</ng-container>
